<template>
    <div class="row">
        <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
            <div class="service-grid">
                <div class="ht-service-box--two text-center style-03">
                    <router-link to="">
                        <div class="image mb-20">
                            <img :src="item.icon" class="img-fluid" alt="aeroland-startup-box-icon-01">
                        </div>
                        <div class="content">
                            <h5 class="heading font-weight-bold" style="color: #000">{{ item.heading }}</h5>
                            <div class="service_text">{{ item.text }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartUpFeatureTwo',
        data (){
            return {
                items: [
                    {
                       icon: require('@/assets/img/img-forum/medalla.svg'), 
                       heading: 'Metodología', 
                       text: 'Nuestra formación MásterPRO está certificada por la norma internacional de calidad de formación virtual, UNE-66181:2012, y la norma de eficiencia en el funcionamiento de un sistema educativo, ISO 21001:2018.'
                    },
                    {
                        icon: require('@/assets/img/img-forum/portafolio.svg'), 
                        heading: 'Portafolio', 
                        text: 'Materiales con referencias y reflexiones sobre cada tema.  Cada documento refuerza, documenta, comprueba y valora lo aprendido.'
                    },
                    {
                        icon: require('@/assets/img/img-forum/certificado.svg'), 
                        heading: 'Diplomas', 
                        text: 'Al finalizar cada curso recibirás un diploma personal otorgado por el Departamento Pedagógico de Progrentis.'
                    },
                ]
            }
        }
    }
</script>
